import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from '../../../app/store'
import fetchAPI from "../../../common/fetchAPI";
import { DepartmentStateClass } from "./interfaces/DepartmentStateClass";
const initialState: DepartmentStateClass = {
    isLoading: false,
    status: 'idle',
    departmentList: [],
    selectedRecord: {},
    isReload : false
}

interface IThunkApi {
    state: {
        department: DepartmentStateClass;
    },
}

export const getAccountDepartmentsAsync = createAsyncThunk
<any, void, IThunkApi>
(
'department/getAccountDepartments',
async (arg, thunkApi) => {
    const response = await fetchAPI('api/Departments', 'Get','',true,'32f92e58-03dc-4d13-960f-e34e26d3e6a5');
    //console.log(response);
    const json = await response.json();
    return json;
}
)

export const getAccountDepartmentByAccountDepartmentIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'department/getAccountDepartmentByAccountDepartmentId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/Departments/' + arg, 'Get', '', true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
            const json = await response.json();
            return json;
        }
    )

export const addAccountDepartmentAsync = createAsyncThunk
<any, any, IThunkApi>
(
    'department/addDepartment',
    async (arg, thunkApi) => {
        const response = await fetchAPI('api/departments/', 'POST', arg, true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
        const json = await response.json();
        return json;
    }
)

export const updateAccountDepartmentAsync = createAsyncThunk
<any, any, IThunkApi>
(
    'department/updateAccountDepartment',
    async (arg, thunkApi) => {
        //const {AccountDepartmentId} = arg;
        const { AccountDepartmentId, ...argWithoutId } = arg;
        const response = await fetchAPI('api/departments/' + AccountDepartmentId, 'POST', argWithoutId, true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
        const json = await response.json();
        return json;
    }
)

export const deleteAccountDepartmentAsync = createAsyncThunk
<any, any, IThunkApi>
(
    'department/deleteAccountDepartment',
    async (arg, thunkApi) => {
        const response = await fetchAPI('api/departments/' + arg, 'DELETE', '', true, '32f92e58-03dc-4d13-960f-e34e26d3e6a5');
        const json = await response.json();
        return json;
    }
)

export const departmentSlice = createSlice({
    name: 'department',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(getAccountDepartmentsAsync.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(getAccountDepartmentsAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            //console.log('getAccountDepartmentsAsync.fulfilled', payload);
            state.departmentList = payload;
            state.isReload = false;
            state.selectedRecord = {};
        })
        .addCase(getAccountDepartmentsAsync.rejected, (state) => {
            state.status = 'failed';
        })
        .addCase(getAccountDepartmentByAccountDepartmentIdAsync.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(getAccountDepartmentByAccountDepartmentIdAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            console.log('getAccountDepartmentByAccountDepartmentIdAsync.fulfilled', payload);
            state.selectedRecord = payload[0];
        })
        .addCase(getAccountDepartmentByAccountDepartmentIdAsync.rejected, (state) => {
            state.status = 'failed';
        })
        .addCase(addAccountDepartmentAsync.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(addAccountDepartmentAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            // console.log('addAccountDepartmentAsync.fulfilled', payload);
            // state.roleList.push(payload);
            state.isReload = true;
        })
        .addCase(addAccountDepartmentAsync.rejected, (state) => {
            state.status = 'failed';
        })
        .addCase(updateAccountDepartmentAsync.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(updateAccountDepartmentAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            // console.log('updateAccountDepartmentAsync.fulfilled', payload);
            // const { AccountDepartmentId } = payload;
            // const index = state.breakTypeList.findIndex((record) => record.AccountDepartmentId === AccountDepartmentId);
            // const newArray = [...state.breakTypeList];
            // newArray[index] = payload;
            // state.breakTypeList = newArray;
            state.isReload = true;
        })
        .addCase(updateAccountDepartmentAsync.rejected, (state) => {
            state.status = 'failed';
        })
        .addCase(deleteAccountDepartmentAsync.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(deleteAccountDepartmentAsync.fulfilled, (state, { payload }) => {
            state.status = 'idle';
            // console.log('deleteAccountBreakTypeAsync.fulfilled', payload);
            // const { AccountBreakTypeId } = payload;
            // state.status = 'idle';
            // const updatedDataList = state.breakTypeList.filter(c => c.AccountBreakTypeId !== AccountBreakTypeId);
            // console.log('updatedDataList', updatedDataList);
            // state.breakTypeList = updatedDataList;
            state.isReload = true;
        })
        .addCase(deleteAccountDepartmentAsync.rejected, (state) => {
            state.status = 'failed';
        })
    }
})

export const {
    resetSelectedRecordObjectInState
} = departmentSlice.actions
export const DepartmentState = (state: RootState) => state.department
export default departmentSlice.reducer
